import { useMutation } from '@tanstack/react-query';
import { getMaterials } from '../queries/module';
import { useMaterialStore } from '../stores/materialStore';
import { useMaterialRequestStore } from '../stores/materialRequestStore';

export function useMaterial() {
  const setMaterials = useMaterialStore.getState().setMaterials;
  const setStoredMaterials = useMaterialRequestStore.getState().setMaterials;
  
  const { mutate, isPending, isError } = useMutation({ 
    mutationKey: ['material'], 
    mutationFn: (modulo: string) => getMaterials(modulo),
    retry: false,
    onSuccess: (result) => {
      setMaterials(result)
      setStoredMaterials(result)
    }
  });

  return { mutate, isPending, isError };
}
